import {
  breakpoints,
  customScrollMinimal,
  typographyV2,
  values,
} from '@toggle/design-system';
import styled from 'styled-components';

export const SourcesHeader = styled.h4`
  padding: 4px 12px;
  ${typographyV2.bodySm};
  color: var(--text-soft);
  border-bottom: 1px solid var(--border-soft);
`;

export const StickySourcesHeader = styled(SourcesHeader)`
  ${typographyV2.bodySm};
  position: sticky;
  top: -1px;
  background-color: var(--background-soft);
`;

export const SourcesList = styled.div`
  max-height: 30vh;
  overflow-y: auto;
  overflow-x: hidden;
  ${customScrollMinimal};
  border-bottom-left-radius: ${values.r2};
  display: flex;
  flex-direction: column;

  @media ${breakpoints['max-sm']} {
    max-height: 20vh;
  }
`;
